import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    variant: 'backgrounds.gradient1',
    padding: '3px',
    borderRadius: '12px',
    color: 'black.100',
    textAlign: 'center',
    width: ['336px', '715px'],
    minHeight: ['195px', '415px'],
  },
  innerContent: {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: ['14px 25px 9px', '56px 40px 40px'],
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  pullQuote: {
    marginBottom: ['4px', '35px'],
    height: ['95px', '145px'],
  },
  fullName: {},
  position: {
    marginBottom: ['6px', '26px'],
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: ['90px', '300px'],
    maxHeight: ['30px', '70px'],
    margin: '0 auto',
  },
  image: {
    width: '100%',
    height: '100%',
    img: {
      objectFit: 'scale-down !important',
    },
  },
};
